module.exports = __webpack_public_path__ + "static/media/liveeel.4c737628.webp";